import { USERNAME_ROLE_MAP } from "../config/usernameRoleMap";

/**
 * Prefer auth.role from API when present; otherwise map username.
 * @param {{ role?: string, username?: string } | null} auth
 * @returns {string | null}
 */
export function resolveUserRole(auth) {
  if (!auth) return null;

  const rawRole = auth.role ? String(auth.role).toUpperCase() : null;
  if (rawRole) {
    return rawRole;
  }

  if (auth.username && USERNAME_ROLE_MAP[auth.username]) {
    return USERNAME_ROLE_MAP[auth.username];
  }

  return null;
}
